import { z } from 'zod';
import { isEmptyHTMLText } from '../helpers';
export function requiredStringSchema(modifySchema) {
    const baseSchema = z.string().trim().min(1);
    const schema = z.preprocess(
    // this is needed to trigger required validation
    (value) => value || undefined, modifySchema ? modifySchema(baseSchema) : baseSchema);
    return schema;
}
export function requiredHTMLStringSchema(modifySchema) {
    const baseSchema = z.string().trim().min(1);
    const schema = z.preprocess(
    // empty rich-text (e.g. `<p></p>`) should count as empty to trigger required validation
    (value) => {
        if (typeof value === 'string' && isEmptyHTMLText(value)) {
            return undefined;
        }
        return value || undefined;
    }, modifySchema ? modifySchema(baseSchema) : baseSchema);
    return schema;
}
export function numberAsStringSchema(modifySchema) {
    const baseSchema = z.number();
    const schema = z
        .ostring()
        .transform((value) => (value ? Number(value) : undefined))
        .pipe(modifySchema ? modifySchema(baseSchema) : baseSchema)
        .transform((value) => value?.toString() ?? '');
    return schema;
}
export const optionSchema = (value, settings) => z.object({
    label: z.string(),
    value,
    active: z.boolean().optional(),
    marked: z.boolean().optional(),
}, settings);
export const nullableRequired = (schema, message) => schema
    .nullable()
    .refine((value) => value !== null, { message })
    .transform((v) => v);
